module.exports = __webpack_public_path__ + "static/media/DisputeResolutionJournal.464d0cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/DisputeResolutionJournal.jpg
// module id = 1323
// module chunks = 1